import React, { useState, useEffect } from "react";
import Gallery from "react-photo-gallery";
import SelectedPhoto from "components/atoms/photoGrallery/SelectedPhoto";
import SortableGallery from "components/molecures/CmsSortableGallery";
import arrayMove from "array-move";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { Check, Sort, DeleteOutline } from "@material-ui/icons";

import { Fab, Zoom } from "@material-ui/core";

export type Photo = {
  id: string;
  src: string;
  width: number;
  height: number;
};

type Props = {
  photos: Photo[];
  onChange?: (photos: Photo[]) => void;
  onSelect?: (photos: Photo[]) => void;
  mode?: String;
  removeFunc?: (photos: Photo[]) => void;
};

export default function Alubum(props: Props) {
  const { photos, mode, onChange, onSelect, removeFunc } = props;

  const [selectAll, setSelectAll] = useState(false);
  const [selectedMode, setSelectedMode] = useState(mode || "sort");
  const [selectedPhotos, setSelectedPhotos] = useState<Photo[]>([]);

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
  };

  const [items, setItems] = useState<Photo[]>(photos ? photos : []);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (onChange) {
      onChange(arrayMove(photos, oldIndex, newIndex));
    }
  };

  const removePhots = () => {
    if (removeFunc) {
      removeFunc(selectedPhotos);
      setSelectedPhotos([]);
      setSelectAll(false);
    }
  };

  const imageRenderer = ({ index, left, top, key, photo }) => (
    <SelectedPhoto
      selected={selectAll ? true : false}
      key={key}
      margin={"2px"}
      index={index}
      photo={photo}
      left={left}
      top={top}
      onChange={(photo: Photo, mode: string) => {
        if (mode === "add") {
          setSelectedPhotos([...selectedPhotos, photo]);
        } else {
          setSelectedPhotos(
            selectedPhotos.filter((sPhoto) => sPhoto.id !== photo.id)
          );
        }
      }}
    />
  );

  useEffect(() => {
    if (onSelect) {
      onSelect(selectedPhotos);
    }
  }, [selectedPhotos]);

  useEffect(() => {
    if (onChange) {
      onChange(items);
    }
  }, [items, onChange]);

  return (
    <div style={{ position: "relative" }}>
      <p>
        {!mode && (
          <ToggleButtonGroup
            value={selectedMode}
            exclusive
            onChange={(event, value) => {
              if (value !== null) {
                setSelectedMode(value);
              }
            }}
            aria-label="text alignment"
          >
            <ToggleButton value="check" aria-label="left aligned">
              <Check />
            </ToggleButton>
            <ToggleButton value="sort" aria-label="centered">
              <Sort />
            </ToggleButton>
          </ToggleButtonGroup>
        )}
      </p>
      {selectedMode === "check" && (
        <Gallery photos={photos} renderImage={imageRenderer} />
      )}
      {selectedMode === "sort" && (
        <SortableGallery items={photos} onSortEnd={onSortEnd} axis={"xy"} />
      )}
      {removeFunc && (
        <Zoom
          in={selectedMode === "check" && selectedPhotos.length > 0}
          style={{ position: "fixed", top: "200px" }}
          unmountOnExit
        >
          <Fab color="primary" onClick={removePhots}>
            <DeleteOutline />
          </Fab>
        </Zoom>
      )}
    </div>
  );
}
